import { isMealboxBasketType } from "./basket";

type CalculateOrderPointsParams = {
  totalSum: number;
  multiplier: number;
};

type GetDeliveryFeeForWeekParams = {
  calendar?: {
    week: number;
    year: number;
    baskets: {
      basketTypeId: string;
      shippingDetails: {
        plannedDeliveryInformation: {
          customerFee: number;
        };
      };
    }[];
  }[];
  week: number;
  year: number;
  loyaltyLevel?: number;
};

export const calculateOrderPoints = ({
  totalSum,
  multiplier,
}: CalculateOrderPointsParams) => {
  return Math.round(totalSum * multiplier);
};

export const getDeliveryFeeForWeek = ({
  calendar,
  week,
  year,
  loyaltyLevel,
}: GetDeliveryFeeForWeekParams) => {
  if (loyaltyLevel === 4 || !calendar) {
    return 0;
  }

  const currentCalendarWeek = calendar?.find(
    (w) => w.week === week && w.year === year,
  );

  const mealboxBasket = currentCalendarWeek?.baskets.find(isMealboxBasketType);
  const deliveryInformation =
    mealboxBasket?.shippingDetails.plannedDeliveryInformation;

  const deliveryFee = deliveryInformation?.customerFee || 0;

  return deliveryFee;
};
